import React, { useMemo, useCallback } from 'react';
import styled from 'styled-components';
import usePublications from '@ubeya/shared/hooks/account/usePublications';
import { Modal as BaseModal, Wizard, FlexColumn } from '@ubeya/shared-web/components';

import PublishSettings from './PublishSettings';

const Modal = styled(BaseModal)`
  height: 63vh;
  max-height: unset;

  > .content {
    overflow: hidden;
    > form {
      overflow: hidden;
    }
  }
`;

const Container = styled(FlexColumn)`
  flex: 1;
  overflow: hidden auto;
  max-height: 100%;
`;

const PublishSettingsModal = ({
  onClose,
  publicationIds,
  conditions,
  className,
  toAddMessage,
  consolidate = false,
  isCheckAvailabilityNeeded = false
}) => {
  const initialValues = useMemo(
    () => ({
      notification: {
        publish: 'publishNow',
        pushNotification: true,
        email: false,
        conditions
      }
    }),
    [conditions]
  );

  const { notifyPublications, notifyBulkPublications } = usePublications({ publicationIds });

  const handleSubmit = useCallback(
    async (values) => {
      if (!consolidate || publicationIds.length === 1) {
        await notifyPublications(values.notification);
      } else {
        await notifyBulkPublications({ publicationIds, ...values.notification });
      }
      onClose();
    },
    [consolidate, notifyBulkPublications, notifyPublications, onClose, publicationIds]
  );

  return (
    <Modal
      onClose={onClose}
      size="medium"
      title="notifyUsers"
      showConfirmButton={false}
      closeOnClickOutside={false}
      isPaddingContent={false}
      className={className}
      usePortal>
      <Wizard initialValues={initialValues} onSubmit={handleSubmit}>
        <Wizard.Page>
          <Container>
            <PublishSettings toAddMessage={toAddMessage} isCheckAvailabilityNeeded={isCheckAvailabilityNeeded} />
          </Container>
        </Wizard.Page>
      </Wizard>
    </Modal>
  );
};

export default PublishSettingsModal;
